import { CButton, CImage } from '@coreui/react-pro'
import React from 'react'
import AppFooter from './AppFooter'
import RayBizTechLogo from '../assets/images/logo/RbtLogo.svg'
import AIMLBridgeLogo from '../assets/images/logo/ai_bridge_logo_207X65.png'
import { reduxServices } from '../reducers/reduxServices'
import { useAppDispatch } from '../stateStore'

const SessionTimeout = (): JSX.Element => {
  const dispatch = useAppDispatch()

  const handleLoginAgain = () => {
    dispatch(reduxServices.app.actions.setIsSessionExpired(false))
    window.location.reload() // removing all old states and refreshing
  }
  const tenantKey = localStorage.getItem('tenantKey')

  const displayLogo =
    tenantKey === 'RAYBIZTECH' || tenantKey === 'RAYBIZTECHR'
      ? RayBizTechLogo
      : AIMLBridgeLogo

  return (
    <>
      <div className="d-flex flex-row">
        <div className="wrapper d-flex flex-column min-vh-100 bg-light">
          <div className="session-expire-header">
            <CImage
              src={displayLogo}
              className="cursor-pointer session-expire-logo"
              width={200}
            />
          </div>
          <div className="body flex-grow-1 px-1 session-expire-body">
            <h2 className="session-expire-message">
              Your session has timed out.
            </h2>
            <br />
            <div className="session-expire-button-container">
              <CButton
                className="session-expire-button btn-primary"
                size="sm"
                onClick={handleLoginAgain}
              >
                Click here to login again
              </CButton>
            </div>
          </div>
        </div>
      </div>
      <div className="session-expire-footer">
        <AppFooter />
      </div>
    </>
  )
}

export default SessionTimeout
